import { Container, type ContainerProps } from '@doist/marketist'

import cn from 'clsx'

import css from './container-two-column.module.css'

type Breakpoints = 'md' | 'lg' | 'xlg'

type ContainerTwoColumnsProps = {
    children: React.ReactNode
    width?: Extract<ContainerProps['width'], 'base' | 'lg'>
    className?: string
    padded?: ContainerProps['padded']
    breakAbove?: Breakpoints
}

export function ContainerTwoColumns({
    children,
    width = 'lg',
    className,
    breakAbove = 'md',
    padded = true,
}: ContainerTwoColumnsProps) {
    return (
        <Container
            width={width}
            padded={padded}
            className={cn(css.containerTwoColumns, css[`breakAbove_${breakAbove}`], className)}
        >
            {children}
        </Container>
    )
}

type BodyContainerProps = {
    children: React.ReactNode
    className?: string
    width?: Extract<ContainerProps['width'], 'base' | 'lg'>
}

ContainerTwoColumns.BodyContainer = function ContainerTwoColumnsBodyContainer({
    children,
    className,
    width = 'lg',
}: BodyContainerProps) {
    return (
        <div className={cn(className)}>
            <div className={cn(css.textContainerInner, css[width])}>{children}</div>
        </div>
    )
}
